export default "__VITE_ASSET__WEYrpmy6__"